// extracted by mini-css-extract-plugin
export default {"betslipButton":"betslipButton-FD9Ao","innerFlexWrapper":"innerFlexWrapper-HvDS0","betButtonLabel":"betButtonLabel-z_a_k","betslipButtonV2":"betslipButtonV2-LYkhH"};